import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetFeatureFlagsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  flagNames: Array<Types.Scalars['String']['input']>;
}>;


export type GetFeatureFlagsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, featureFlags?: Array<{ __typename?: 'FeatureFlag', name: string, enabled: boolean } | null> | null } | null };


export const GetFeatureFlags = /*#__PURE__*/ gql`
    query GetFeatureFlags($accountId: ID!, $flagNames: [String!]!) {
  account(accountId: $accountId) {
    id
    featureFlags(flagNames: $flagNames) {
      name
      enabled
    }
  }
}
    ` as unknown as DocumentNode<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>;

          

          export const useGetFeatureFlagsQuery = (options?:QueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) => useQuery(GetFeatureFlags, options);

          

          export type GetFeatureFlagsQueryOptions = QueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>;

          

          export const useGetFeatureFlagsLazyQuery = (options?:LazyQueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) => useLazyQuery(GetFeatureFlags, options);

          

          export type GetFeatureFlagsQueryResult = ReturnType<typeof useGetFeatureFlagsQuery>;

          
